import React, { useEffect, useState } from 'react';
import { Lock, Zap, ShieldCheck, CreditCard } from 'lucide-react';
const checkoutBasico = 'https://checkout.recursodigital.shop/cart/41357284016186:1';
const checkoutCompleto = 'https://checkout.recursodigital.shop/cart/41357285490746:1';
export function FinalCTA() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 46,
    seconds: 34
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return {
          hours: 23,
          minutes: 59,
          seconds: 59
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const fmt = (v: number) => v.toString().padStart(2, '0');
  return <section className="bg-brand-dark text-white py-5 px-5" data-id="element-111">
      <div className="max-w-xl mx-auto" data-id="element-112">
        {/* Headline */}
        <h2 className="text-xl md:text-3xl font-extrabold mb-10 leading-tight text-center" data-id="element-113">
          El próximo mes podés seguir improvisando…{' '}
          <span className="text-brand-yellow" data-id="element-114">
            o podés empezar a acompañar esta etapa con claridad desde hoy.
          </span>
        </h2>

        {/* Countdown Timer */}
        <div className="text-center mb-10" data-id="element-115">
          <p className="text-sm text-gray-400 mb-4 font-medium" data-id="element-116">
            🚨 El precio de lanzamiento cierra en:
          </p>
          <div className="flex items-end justify-center gap-1 mb-2" data-id="element-117">
            <div className="text-center" data-id="element-118">
              <span className="text-5xl md:text-6xl font-black text-white" data-id="element-119">
                {fmt(timeLeft.hours)}
              </span>
              <p className="text-[10px] text-gray-500 uppercase tracking-wider mt-1" data-id="element-120">
                HS
              </p>
            </div>
            <span className="text-4xl md:text-5xl font-black text-brand-yellow pb-1" data-id="element-121">
              :
            </span>
            <div className="text-center" data-id="element-122">
              <span className="text-5xl md:text-6xl font-black text-white" data-id="element-123">
                {fmt(timeLeft.minutes)}
              </span>
              <p className="text-[10px] text-gray-500 uppercase tracking-wider mt-1" data-id="element-124">
                MIN
              </p>
            </div>
            <span className="text-4xl md:text-5xl font-black text-brand-yellow pb-1" data-id="element-125">
              :
            </span>
            <div className="text-center" data-id="element-126">
              <span className="text-5xl md:text-6xl font-black text-white" data-id="element-127">
                {fmt(timeLeft.seconds)}
              </span>
              <p className="text-[10px] text-gray-500 uppercase tracking-wider mt-1" data-id="element-128">
                SEG
              </p>
            </div>
          </div>
          <p className="text-xs text-gray-500 mt-3" data-id="element-129">
            Después sube y no vuelve a bajar...
          </p>
        </div>

        {/* Two pricing cards side by side */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6" data-id="element-130">
          {/* Basic */}
          <div className="bg-gray-900 border border-gray-700 rounded-xl p-5 text-center flex flex-col" data-id="element-131">
            <div className="text-3xl mb-2" data-id="element-132">📘</div>
            <h4 className="text-sm font-black text-white uppercase mb-1" data-id="element-133">
              MEGA PACK AFRONTAR LA VEJEZ DE TUS PADRES™
            </h4>
            <p className="text-[11px] text-gray-500 mb-4" data-id="element-134">6 Tomos + 6 Bonos</p>
            <div className="mt-auto" data-id="element-135">
              <div className="text-xs text-gray-600 line-through mb-0.5" data-id="element-136">
                S/.49.90
              </div>
              <div className="text-2xl font-black text-white mb-4" data-id="element-137">
                S/.29.90
              </div>
              <a href={checkoutBasico} className="block w-full border-2 border-brand-yellow text-brand-yellow font-black text-sm py-3 px-4 rounded-xl hover:bg-brand-yellow/10 transition-colors text-center" data-id="element-138">
                → QUIERO MI MEGAPACK
              </a>
            </div>
          </div>

          {/* Complete */}
          <div className="bg-gray-900 border-2 border-brand-yellow rounded-xl p-5 text-center flex flex-col" data-id="element-139">
            <div className="text-3xl mb-2" data-id="element-140">🏆</div>
            <h4 className="text-sm font-black text-white uppercase mb-1" data-id="element-141">
              MEGAPACK + SISTEMA FAMILIA ORGANIZADA™ ⭐
            </h4>
            <p className="text-[11px] text-gray-400 mb-4" data-id="element-142">
              6 Tomos + 6 Bonos + Sistema
            </p>
            <div className="mt-auto" data-id="element-143">
              <div className="text-xs text-gray-600 line-through mb-0.5" data-id="element-144">
                S/.99.90
              </div>
              <div className="text-2xl font-black text-white mb-4" data-id="element-145">
                S/.69.90
              </div>
              <a href={checkoutCompleto} className="block w-full bg-brand-yellow hover:bg-brand-yellowHover text-black font-black text-sm py-3 px-4 rounded-xl shadow-[0_4px_14px_0_rgba(251,191,36,0.3)] transition-all hover:scale-[1.02] text-center" data-id="element-146">
                → QUIERO EL SISTEMA COMPLETO
              </a>
            </div>
          </div>
        </div>

        {/* Trust badges */}
        <div className="text-center space-y-2 mt-8" data-id="element-147">
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[11px] font-semibold text-gray-400" data-id="element-148">
            <div className="flex items-center gap-1.5" data-id="element-149">
              <Lock size={13} className="text-brand-yellow" data-id="element-150" />
              Pago 100% seguro
            </div>
            <div className="flex items-center gap-1.5" data-id="element-151">
              <Zap size={13} className="text-brand-yellow" data-id="element-152" />
              Acceso en 5 minutos
            </div>
            <div className="flex items-center gap-1.5" data-id="element-153">
              <ShieldCheck size={13} className="text-brand-yellow" data-id="element-154" />
              Garantía 7 días sin preguntas
            </div>
          </div>
          <div className="flex items-center justify-center gap-1.5 text-gray-500 text-[14px] font-[600]" data-id="element-155">
            Paga con Yape, tarjeta o MercadoPago de forma segura y accede al
            material HOY
          </div>
        </div>
      </div>
    </section>;
}